module.exports = __webpack_public_path__ + "static/media/liveSurveyTemp.ef6a0ba3.xlsx";